import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { message as defaultMessage } from 'ifield-core-components'
import myMessage from '@/assets/message'
import ObjectUtil from '@/js/util/ObjectUtil'

// 多言語対応
Vue.use(VueI18n)

// 多言語変換ファイル読込み
const messageData = ObjectUtil.deepDefaults(myMessage, defaultMessage)

const i18n = new VueI18n({
  locale: window.navigator.language,
  fallbackLocale: 'en',
  silentFallbackWarn: true,
  messages: messageData,
})

export default i18n

/**
 * アクティブロケールの取得
 * 'ja'で始まるロケールでなければ fallback を返す
 * @returns {string}
 */
export const getActiveLocale = () =>
  i18n.locale.slice(0, 2) === 'ja' ? i18n.locale : i18n.fallbackLocale
